import { useState } from 'react';
import { StanButton } from '@/components';
import PayPalLogo from '@/assets/icons/payments/paypal.svg';

interface PayPalAccountConnectProps {
    onConnect: () => void;
}

export const PayPalAccountConnect = ({ onConnect }: PayPalAccountConnectProps) => {
    const [processing, setProcessing] = useState(false);

    const handleConnect = () => {
        setProcessing(true);
        onConnect();
    };

    return (
        <div className='bg-bg-canvas h-svh overflow-y-auto'>
            <div className='flex min-h-full flex-col justify-center py-8'>
                <div className='container mx-auto flex flex-col px-4'>
                    <PayPalLogo className='mx-auto max-w-lg' />

                    <div className='mt-16 text-center'>
                        <h2 className='text-heading-h2 font-bold'>Start Selling & Get Paid</h2>
                        <p className='text-body-sm text-gray mx-auto mt-4 max-w-xl'>
                            To start accepting payments, we recommend using a <strong>PayPal Business Account</strong>.
                            Personal accounts may require additional business details.
                        </p>
                    </div>
                </div>

                <div className='container mx-auto mt-6 max-w-md px-4 text-center'>
                    <StanButton
                        name='paypal-connect-button'
                        className='w-full'
                        loading={processing}
                        disabled={processing}
                        onClick={handleConnect}
                    >
                        Connect to PayPal
                    </StanButton>

                    <p className='text-caption-1-regular text-gray mt-2'>You will be redirected to PayPal.</p>
                </div>
            </div>
        </div>
    );
};
